// constants

const SET_DIALOG_LOGIN = "SET_DIALOG_LOGIN";

// reducers

const initialState = false;

// eslint-disable-next-line
export default (state = initialState, action) => {
	switch (action.type) {
		case SET_DIALOG_LOGIN:
			return action.payload;

		default:
			return state;
	}
};

// actions

// const resolveAfter2Seconds = () => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve("resolved");
// 		}, 2000);
// 	});
// };

export const setDialogLogin = (payload = false) => {
	return {
		type: SET_DIALOG_LOGIN,
		payload: payload,
	};
};
